export const ICON_NAMES = {
  CLOCK: 'clock',
  SP_HISTORY: 'sp-history',
  SUBSCRIBE_ICON: 'subscribe-icon',
  CAT_PLAY: 'issue-play',
  CAT_PAUSE: 'issue-pause',
  CAT_IN_APP: 'cat-in-app',
  THRESHOLD_INFO: 'threshold-info-icon',
  COLLAPSE: 'collapse',
  SOUND_ON: 'sound-on',
  SOUND_OFF: 'sound-off',
  PDF_DOWNLOAD: 'pdf-download-icon',
  UNSUBSCRIBE_ICON: 'unsubscribe-icon',
  DOWNLOAD_PDF_ICON: 'download-pdf-icon',
  SCROLL_TO_TOP : 'page_up'
} as const;

export type IconName = (typeof ICON_NAMES)[keyof typeof ICON_NAMES];
